import { SortPage, SortDirection } from './../../../models/pagination/sort-page';
import { Party } from '../../../models/party-manager/party';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, PageEvent } from '@angular/material';
import { SearchObject } from 'src/app/models/pagination/search-object';
import { TaskManagementService,Queue } from 'src/app/services/api/taskmanagement/taskmanagement.service';
import { DeleteQueueComponent } from './delete-queue/delete-queue.component';
import { UpdateQueueComponent }  from './update-queue/update-queue.component';

@Component({
  selector: 'app-taskmanagement',
  templateUrl: './taskmanagement.component.html',
  styleUrls: ['./taskmanagement.component.scss']
})
export class TaskManagementComponent implements OnInit, AfterViewInit {

  @ViewChild(MatSort, { static: false }) sort: MatSort;

  elements: Queue[]

  resultsLength:number = 0;

  searchObject:SearchObject = new SearchObject(10,0);
  sortPage: SortPage= new SortPage("createdAt",SortDirection.DESC);

  tooltip = {
    refresh: '',
    edit: '',
    delete: ''
  }

  displayedColumns: string[] = [
    'name',
    'description',
    'rol',
    'priority',
    'actions'
  ];

  form: FormGroup;

  constructor(
    private translate: TranslateService,
    private taskManagementService: TaskManagementService,
    private router: Router,
    private dialog: MatDialog,
     ) { }

  ngAfterViewInit(): void {
   this.sort.sortChange.subscribe(data =>{
    this.sortPage = new SortPage(data['active'],SortDirection[data['direction'].toUpperCase()] as SortDirection);
    this.searchObject.sort= this.sortPage;
    this.getQueues()
   });
  }

  ngOnInit() {
    this.getQueues()
    this.initTooltips();
  }


  private initTooltips() {
    this.translate.get('DUMMY.key').subscribe((translated: string) => {
      this.tooltip.refresh = this.translate.instant('TOOLTIPS.refreshResults');
      this.tooltip.edit = this.translate.instant('TOOLTIPS.updateQueue');
      this.tooltip.delete = this.translate.instant('TOOLTIPS.deleteQueue');
    });
  }

  getQueues(){
    this.searchObject.sort = this.sortPage
    this.taskManagementService.getQueues().subscribe(
    data =>{
      this.elements = data
      this.resultsLength = this.elements.length
    });

  }

  delete(queue:Queue){
    const matDialogRef = this.dialog.open(DeleteQueueComponent, {
      data: {
        queue
      }
    });
    matDialogRef.afterClosed().subscribe(()=>this.getQueues());
  }

  update(queue:Queue){
    const matDialogRef = this.dialog.open(UpdateQueueComponent, {
      data: {
        queue
      },
      disableClose: true,
      hasBackdrop: true,
      width: '75%',
      maxHeight: '70%',
      restoreFocus: false,
      autoFocus: false
    });
    matDialogRef.afterClosed().subscribe(()=>this.getQueues());
  }

  goToNewQueue(){
    this.router.navigate([`/provision/management/taskmanagement/add-queue`]);
  }

  search(){
    this.getQueues();
  }

}
